import React from 'react';

import { Nav, NavItem, TabContent, TabPane } from 'reactstrap';

import { Link, withRouter } from 'react-router-dom';

import classnames from 'classnames';

import { Scrollbars } from 'react-custom-scrollbars-2';

const styles = {
	nav: { flexWrap: 'nowrap' },
	scrollbars: { height: '50px', whiteSpace: 'nowrap' },
};

class DemoraTabs extends React.PureComponent {
	constructor(props) {
		super();

		this.state = {
			tabsOpened: {},
			param: props.param ? props.param : 'tab',
		};
	}

	componentDidMount() {
		this.markTabAsOpened(this.getCurrentTabTitle(), 1);
	}

	componentDidUpdate(oldProps) {
		const state = this.state;

		const props = this.props;

		const tab =
			props.match.params[state.param] || this.camelize(props.tabs[0].title);

		const old_tab =
			oldProps.match.params[state.param] ||
			this.camelize(oldProps.tabs[0].title);

		if (tab == old_tab) {
			return;
		}

		this.markTabAsOpened(tab, 1);
	}

	toggle = (tab) => {
		this.markTabAsOpened(tab.title, 1);

		if (this.props.onChange) {
			this.props.onChange(tab);
		}
	};

	markTabAsOpened(title, st) {
		const state = this.state;

		const tabsOpened = Object.assign({}, state.tabsOpened);

		if (tabsOpened[this.camelize(title)] == st) {
			this.closeTabsThatShouldBeDestroyed();

			return;
		}

		tabsOpened[this.camelize(title)] = st;

		this.setState(
			{
				tabsOpened: Object.assign({}, tabsOpened),
			},
			this.closeTabsThatShouldBeDestroyed
		);
	}

	getCurrentTabTitle() {
		const state = this.state;

		const props = this.props;

		let ct = props.match.params[state.param];

		if (!ct) {
			ct = props.defaultTab;
		}

		if (!ct) {
			ct = props.tabs[0].title;
		}

		return ct;
	}

	closeTabsThatShouldBeDestroyed() {
		const state = this.state;

		const props = this.props;

		const tabsOpened = Object.assign({}, state.tabsOpened);

		const currentTitle = this.camelize(this.getCurrentTabTitle());

		const tabsToClose = {};

		props.tabs.map((t) => {
			const tt = this.camelize(t.title);

			if (tt != currentTitle && tabsOpened[tt] && t.destroyTab) {
				tabsToClose[tt] = null;
			}
		});

		if (Object.keys(tabsToClose).length > 0) {
			this.setState({
				tabsOpened: Object.assign({}, tabsOpened, tabsToClose),
			});
		}
	}

	camelize(str) {
		str = str.charAt(0).toUpperCase() + str.slice(1);

		return str
			.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
				return index === 0 ? word.toLowerCase() : word.toUpperCase();
			})
			.replace(/\s+/g, '');
	}

	render() {
		const state = this.state;

		const props = this.props;

		let activeTab = this.getCurrentTabTitle();

		const tabs = props.tabs;

		const tabsOpened = state.tabsOpened;

		return (
			<div>
				<Scrollbars style={styles.scrollbars}>
					<Nav style={styles.nav} tabs>
						{tabs.map((tab, i) => {
							const t = i + 1 + '';

							const title = tab.title;

							if (this.camelize(activeTab) === this.camelize(title)) {
								activeTab = t;
							}

							if (props.hideTabLinks === false) {
								return null;
							}

							return (
								<NavItem key={t}>
									<Link
										to={
											`${props.uri}/${this.camelize(title)}` +
											(props.includeQueryString
												? this.props.location.search
												: '')
										}
										className={classnames(props.navClassName, 'nav-link', {
											active: activeTab === t,
										})}
										onClick={() => {
											this.toggle(tab);
										}}
										id={tab.tabId}
									>
										{tab.tabLabel ? tab.tabLabel : title}
									</Link>
								</NavItem>
							);
						})}
					</Nav>
				</Scrollbars>
				<TabContent activeTab={activeTab} className='mt-3'>
					{tabs.map((tab, i) => {
						if (!tabsOpened[this.camelize(tab.title)]) {
							return null;
						}

						const t = i + 1 + '';

						return (
							<TabPane tabId={t} key={i} id={tab.paneId}>
								{tab.pane}
							</TabPane>
						);
					})}
				</TabContent>
			</div>
		);
	}
}

export default withRouter(DemoraTabs);
